<div class="nova-dialog">
  <button
    class="close-btn"
    mat-icon-button
    (click)="close()"
    aria-label="Close Amazon Nova Lite Info"
  >
    ×
  </button>

  <div class="header">
    <img src="assets/logos/amazon.svg" alt="Amazon Nova Lite Logo" class="logo" />
    <h2>Amazon Nova Lite</h2>
    <div class="sub">
      Low-latency Bedrock chat model — fast, efficient, and production-ready for high-volume workflows
    </div>
  </div>

  <div class="body">
    <p>
      <strong>Amazon Nova Lite</strong> is AWS’s lightweight Nova model designed for
      <strong>high-throughput text/chat</strong> use cases where
      <strong>speed, cost-efficiency, and predictable latency</strong> matter most.
      It’s a strong “default” assistant model for production apps that need responsive answers,
      stable instruction following, and business-friendly output quality.
    </p>

    <ul>
      <li><strong>⚡ Fast responses at scale:</strong> optimized for low-latency chat experiences and high request volumes.</li>
      <li><strong>🧾 Clean instruction following:</strong> reliable compliance with prompts, formatting, and workflow constraints.</li>
      <li><strong>🧠 Practical everyday reasoning:</strong> strong for summaries, extraction, and operational Q&A without heavy “deep reasoning” overhead.</li>
      <li><strong>🧩 Workflow-friendly outputs:</strong> works well for structured responses (bullets, steps, short plans) and predictable tone.</li>
      <li><strong>🧷 Great for internal assistants:</strong> ideal for knowledge base Q&A, helpdesk triage, internal ops copilots, and repeatable business tasks.</li>
      <li><strong>🛡️ Enterprise guardrails:</strong> built for managed AWS deployment patterns and production governance expectations in Bedrock.</li>
      <li><strong>☁️ AWS-native integration:</strong> simple to run inside Bedrock with IAM, logging/monitoring patterns, and enterprise deployment controls.</li>
    </ul>

    <div class="optimal">
      <h3>When is Amazon Nova Lite optimal?</h3>
      <ul>
        <li>When you want <strong>fast and affordable</strong> chat responses for daily usage</li>
        <li>For <strong>summaries</strong>, <strong>rewrite tasks</strong>, and <strong>structured extraction</strong> (notes → bullets, fields → JSON)</li>
        <li>For <strong>support-style assistants</strong> (FAQ bots, ticket triage, internal helpdesk)</li>
        <li>For <strong>high-volume workflows</strong> where consistency and predictable latency beats deep “frontier reasoning”</li>
        <li>When you want an AWS-managed model that fits cleanly into <strong>Bedrock</strong> production patterns</li>
      </ul>
    </div>

    <div class="optimal">
      <h3>Practical design pattern</h3>
      <ul>
        <li>Use Nova Lite for <strong>first-pass</strong> tasks: summarize, classify, extract fields, rewrite, route requests</li>
        <li>Escalate to a heavier model only when needed (complex planning, deep code review, long-horizon reasoning)</li>
        <li>Ask for <strong>structured outputs</strong> (bullets / sections / JSON) to keep responses stable and UI-friendly</li>
        <li>Keep prompts <strong>short and specific</strong> for best throughput and predictable results</li>
      </ul>
    </div>
  </div>
</div>
